import React , { useState, useRef, useEffect, useCallback } from 'react';

import dayjs from 'dayjs'
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import CP from '@material-ui/core/CircularProgress';
import 'video-react/dist/video-react.css';

import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import GetAppIcon from '@material-ui/icons/GetApp';
import ExploreIcon from '@material-ui/icons/Explore';
import TodayIcon from '@material-ui/icons/Today';
import SwitchVideoIcon from '@material-ui/icons/SwitchVideo';
import VideocamIcon from '@material-ui/icons/Videocam';
import VisibilityIcon from '@material-ui/icons/Visibility';
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';

import {   Player,
  ControlBar,
  BigPlayButton,
  ProgressControl,
  FullscreenToggle,
  DurationDisplay,
  ReplayControl,
  ForwardControl,
  CurrentTimeDisplay,
  TimeDivider,
  PlaybackRateMenuButton,
  VolumeMenuButton } from 'video-react';

import { saveAs } from 'file-saver';
import DownloadButton from './DownloadButton';
import IOSSlider from './IOSSlider';

import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';

import DatePicker from 'react-mobile-datepicker';

import _ from 'lodash';

const marks = [ ...Array(23).keys() ].map((v,i)=> {
  return {value: (i+1)*12, label: i%2 == 0 ? (i + 1).toString().padStart(2, '0') : '' }
});



const IMAGEPATH = "/locations/hatta_w/"

export default () => {
  const [value, setValue] = useState(144)
  const [loading, setLoading] = useState(true)
  const [bgImage, setBgImage] = useState()
  const [previewImg, setPreviewImg] = useState()
  const [showPreview, setShowPreview] = useState(false)
  const [showVid, setShowVid] = useState(false)
  const [showSwitchCam, setShowSwitchCam] = useState(false)
  const [camDir, setCamDir] = useState('SouthWest')
  const [datePicker, setDatePicker] = useState(false)
  const [dateValue, setDateValue] = useState()

  const myVideo = useRef(null)

  //const today = dayjs('2019-11-15').set('hour', 0).set('minute', 0)
  //const today = dayjs()

  // custom limits
  // const min = 0
  // const max = 75
  // const valueWithinLimits = v => Math.min(Math.max(v, min), max)

  const monthMap = {
  	'1': 'Jan',
  	'2': 'Feb',
  	'3': 'Mar',
  	'4': 'Apr',
  	'5': 'May',
  	'6': 'Jun',
  	'7': 'Jul',
  	'8': 'Aug',
  	'9': 'Sep',
  	'10': 'Oct',
  	'11': 'Nov',
  	'12': 'Dec',
  };

  const dateConfig = {
  	'year': {
  		format: 'YYYY',
  		caption: 'Year',
  		step: 1,
  	},
  	'month': {
  		format: value => monthMap[value.getMonth() + 1],
  		caption: 'Mon',
  		step: 1,
  	},
  	'date': {
  		format: 'DD',
  		caption: 'Day',
  		step: 1,
  	},
  };

  const valueMinuteFloored = value * 5
  const timeDateValue = dayjs('2019-11-13').add(valueMinuteFloored, 'minute');
  const month = timeDateValue.format('MM') + '/';
  const day   = timeDateValue.format('DD') + '/';
  const hour  = timeDateValue.format('HH') + '/';

  const mediaPathBase = process.env.PUBLIC_URL + IMAGEPATH + month + day
  const imageSmallPathBase = mediaPathBase + 'small/'
  const previewImagePath =  imageSmallPathBase + (value + 1).toString().padStart(6, '0') + '.jpg';
  const bgImagePath = mediaPathBase + hour + timeDateValue.format('YYMMDDHHmm') + '.jpg';
  const previewVid = mediaPathBase + '12/1911131200.jpg';
  const videoPath = mediaPathBase + 'out_960.mp4'

  const currentDate = timeDateValue.format('D MMM YYYY')
  const currentTime = timeDateValue.format('HH:mm')

  useEffect(() => {
    const onPageLoad = async () => {
      console.log('loading ',loading);
      let images = []
      for (var i = 0 ; i < 288 ; i++){
        images[i] = loadImg(i)
      }

      Promise.all(images).then(()=>{
        setLoading(false)
        console.log('images loaded');
      })

      //await Promise.all(images)

      console.log('images loaded');

      //await loadVid2(process.env.PUBLIC_URL + VIDEOPATH)

      setLoading(false)
    };

    const loadImg = i => new Promise( async (resolve) => {
      const img = new Image()
      img.src = imageSmallPathBase + (i + 1).toString().padStart(6, '0') + '.jpg';
      img.onload = () => { resolve() };
    });

    const loadVid2 = path => new Promise( async (resolve) => {
      const res = await fetch(path)
      const blob = await res.blob()
      const src = window.URL.createObjectURL(blob)
      console.log('video loaded');
      resolve();
    });

    const loadVid = path => new Promise( async (resolve) => {
      var req = new XMLHttpRequest();
      req.open('GET', path, true);
      req.responseType = 'blob';

      req.onload = function() {
         // Onload is triggered even on 404
         // so we need to check the status code
         if (this.status === 200) {
            //var videoBlob = this.response;
            //var vid = URL.createObjectURL(videoBlob); // IE10+
            // Video is now downloaded
            // and we can set it as source on the video element
            //video.src = vid;
            resolve()
            console.log('video loaded');
         }
      }
      req.onerror = function() {
         // Error
      }

      req.send();
    });

    onPageLoad()
  }, []);

  useEffect(() => {
    //if (showVid) myVideo.current.toggleFullscreen()
  }, [showVid])

  useEffect(()=>{
    debounceSetBgImage(bgImagePath)
    debounceSetPreview(previewImagePath)

    if (showVid) setShowVid(false)

    // console.log('v',value);
    // console.log('valueMinuteFloored',valueMinuteFloored);
    // console.log('timeDateValue',timeDateValue);
  },[value]);

  const debounceSetBgImage = useCallback( _.debounce((v) => setBgImage(v), 500), []);
  const debounceSetPreview = useCallback( _.debounce((v) => setPreviewImg(v), 3), []);

  const downloadImage = () => { saveAs(bgImage, timeDateValue.format('YY-MM-DD-HHmm') + '.jpg') }
  const switchCamera = () => { setShowSwitchCam(true) }
  const closeSwitchCamera = () => { setShowSwitchCam(false) }
  const selectSwitchCamera = (n) => {
    setCamDir(n);
    closeSwitchCamera()
  }

  const datePickerSelect = (v) => {
    setDatePicker(false)
    console.log('datePickerSelect',v);
  };
  const datePickerCancel = () => {
    setDatePicker(false)
  };

  return (
    <div id="swap2" >
      <div className="bgImgBox"><img src={ bgImage } /></div>

      { loading && <div  id="loading"> <CP /><span>Loading</span> </div> }

      { showVid &&
          <Player muted id="timeVid" ref={myVideo} poster={previewVid} >
            <source src={videoPath} />
            <BigPlayButton position="center" />
            <ControlBar className="vidCtrl">
              <DurationDisplay order={4.1} disabled />
              <TimeDivider order={4.2} disabled />
              <VolumeMenuButton disabled />
              <DownloadButton order={7.1} />
              <FullscreenToggle  order={7.2}/>
            </ControlBar>
          </Player>
      }

      <div id="controls">

        <Button onClick={ () => setShowVid(v => !v)}> { showVid ?  <CancelPresentationIcon /> : <PlayArrowIcon />} </Button>
        <Button onClick={switchCamera}><VideocamIcon /></Button>
        <Button onClick={ () => setValue(144)} ><VisibilityIcon /></Button>
        <Button onClick={ () => setDatePicker(true)}><TodayIcon /></Button>
        <Button onClick={downloadImage}><GetAppIcon /></Button>
      </div>

      <div id="Locationtitle">
        <span className="titleText"> Hatta</span>
        <span className="direction">{ camDir }</span>
      </div>

      { showPreview &&
        <><div className="imgBox"><img src={ previewImg } /></div>
        <div className="dateTime">
          <span className="time">{currentTime}</span>
          <span className="date">{currentDate}</span>
        </div></>
      }

      <IOSSlider
        max={287}
        id="timeline2"
        value={value}
        defaultValue={144}
        marks={marks}
        valueLabelDisplay="on"
        onChange={(e,v)=> setValue(v)}
        onMouseEnter={() => setShowPreview(true)}
        onMouseLeave={() => setTimeout(()=>setShowPreview(false), 300)}
        onTouchStart={() => setShowPreview(true)}
        onTouchEnd={() => setTimeout(()=>setShowPreview(false), 300)}
      />

      <div id="sliderImages">

        { [ ...Array(12).keys() ]
          .map((v, i) => {
            const src = imageSmallPathBase + (i*24+1).toString().padStart(6, '0') + '.jpg';
            return (<img src={src} data-key={i} key={i} style={{ objectPosition: `${i/12*100}% 50%`}} />)
          })
        }
      </div>


     <DatePicker
				value={dateValue}
				isOpen={datePicker}
				onSelect={datePickerSelect}
				onCancel={datePickerCancel}
        dateConfig={dateConfig}
        headerFormat={'YYYY/MM/DD'}
        showHeader={false}
        confirmText="Confirm"
        cancelText="Cancel"
        min={new Date(2018, 0, 1)}
        max={new Date()}
      />

      <Dialog onClose={closeSwitchCamera} open={showSwitchCam}>
         <DialogTitle id="simple-dialog-title">Select Camera</DialogTitle>
         <List>
           <ListItem button onClick={() => selectSwitchCamera('SouthWest')}>
             <ListItemAvatar>
               <Avatar><VideocamIcon /> </Avatar>
             </ListItemAvatar>
             <ListItemText primary="SouthWest" />
           </ListItem>
           <ListItem button onClick={() => selectSwitchCamera('East')}>
             <ListItemAvatar>
               <Avatar><VideocamIcon /></Avatar>
             </ListItemAvatar>
             <ListItemText primary="East" />
           </ListItem>
         </List>
       </Dialog>

    </div>
  )
}
